import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Rodal from 'rodal';

import { LINKS } from '../../Constants';
import { closeGdprModal } from '../../Actions/CareerActions';

const GdprModal = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const dispatch = useDispatch();
  const { text: { gdprModal: pageText } } = useSelector(state => state.Language);
  const { content } = props;

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div>
      <Rodal
        customStyles={{ height: 'auto', bottom: 'auto', top: '2%' }}
        className="career-modal"
        visible={isVisible}
        leaveAnimation="zoom"
        onAnimationEnd={() => {
          if (!isVisible) {
            dispatch(closeGdprModal());
          }
        }}
        onClose={() => {
          setIsVisible(false);
        }}
      >
        <div className="career-modal__header">
          <h3 className="career-modal__title">{pageText.header}</h3>
        </div>
        <p className="career-modal__label">
          {pageText.label1}
        </p>
        <p className="career-modal__text">
          {pageText.p1}
        </p>
        <p className="career-modal__label">
          {pageText.label2}
        </p>
        <p className="career-modal__text">
          {pageText.p2}
        </p>
        <p className="career-modal__label">
          {pageText.label3}
        </p>
        <p className="career-modal__text">
          {pageText.p3}
        </p>
        <p className="career-modal__label">
          {pageText.label4}
        </p>
        <p className="career-modal__text">
          {pageText.p4}
        </p>
        <p className="career-modal__label">
          {pageText.label5}
        </p>
        <p className="career-modal__text">
          {content.text}
        </p>
        <p className="career-modal__label">
          {pageText.label6}
        </p>
        <div
          className="career-modal__link"
          role="link"
          tabIndex="0"
          onClick={() => { window.location.href = content.url; }}
          onKeyPress={() => { window.location.href = content.url; }}
        >
          {content.url}
        </div>
        <p className="career-modal__label">
          {pageText.label7}
        </p>
        <p className="career-modal__text">
          {pageText.p7}
        </p>
        <div
          className="career-modal__link"
          role="link"
          tabIndex="0"
          onClick={() => { window.location.href = LINKS.DATA_INSPEKTIONEN; }}
          onKeyPress={() => { window.location.href = LINKS.DATA_INSPEKTIONEN; }}
        >
          {pageText.p7_2}
        </div>
        <p className="career-modal__label">
          {pageText.label8}
        </p>
        <div
          className="career-modal__link"
          role="link"
          tabIndex="0"
          onClick={
            () => { window.location.href = `mailto:${content.mail}`; }}
          onKeyPress={
            () => { window.location.href = `mailto:${content.mail}`; }}
        >
          {content.mail}
        </div>
        <button
          aria-label="close"
          tabIndex="0"
          onClick={() => { setIsVisible(false); }}
          className="career-modal__close-button"
        />
      </Rodal>
    </div>
  );
};

export default GdprModal;



// WEBPACK FOOTER //
// ./src/Components/Career/GdprModal.js